import React, { useEffect } from 'react';

import { RenderRichText } from '@/components/Layout/components/SongModalPanel/SongModalRoot';
import { Loader } from '@/components/shared/Loader';
import { ModalSectionTitle } from '@/components/shared/ModalSectionTitle';
import { useGetSetlistSummaryMutation } from '@/graphql';

import styles from './SetlistSummary.module.scss';

export interface SetlistSummaryProps {
	teamSongIds: string[];
}

export const SetlistSummary: React.FC<SetlistSummaryProps> = ({
	teamSongIds,
}) => {
	const {
		mutateAsync: getSetlistSummary,
		isLoading,
		data: summaryData,
	} = useGetSetlistSummaryMutation();

	useEffect(() => {
		if (teamSongIds.length > 0) {
			getSetlistSummary({ teamSongIds });
		}
	}, [teamSongIds, getSetlistSummary]);

	if (teamSongIds.length === 0) {
		return (
			<p className={styles['empty']}>
				Add songs to see setlist analysis.
			</p>
		);
	}

	if (isLoading || !summaryData?.getSetlistSummary?.summary) {
		return <Loader fullText="Thinking" height={300} />;
	}

	return (
		<>
			<ModalSectionTitle>Setlist summary</ModalSectionTitle>
			<RenderRichText text={summaryData.getSetlistSummary.summary} />
			<div className="p-sm" />

			<ModalSectionTitle>Themes</ModalSectionTitle>
			<RenderRichText text={summaryData.getSetlistSummary.themes} />
			<div className="p-sm" />

			<ModalSectionTitle>Theology</ModalSectionTitle>
			<RenderRichText text={summaryData.getSetlistSummary.theology} />
			<div className="p-sm" />

			<ModalSectionTitle>Gospel story</ModalSectionTitle>
			<RenderRichText text={summaryData.getSetlistSummary.gospel_story} />
			<div className="p-sm" />

			<ModalSectionTitle>Emotions</ModalSectionTitle>
			<RenderRichText text={summaryData.getSetlistSummary.emotions} />
			<div className="p-sm" />

			<ModalSectionTitle>Energy</ModalSectionTitle>
			<RenderRichText text={summaryData.getSetlistSummary.energy} />
			<div className="p-sm" />

			<ModalSectionTitle>Recommendations</ModalSectionTitle>
			<RenderRichText
				text={summaryData.getSetlistSummary.recommendations}
			/>
		</>
	);
};
